import { defineMessages } from 'react-intl'

export const profilesPageMessages = defineMessages({
  title: {
    id: 'profilesPage.teamTitle',
    description: 'Profiles title on Team page',
    defaultMessage: 'Profiles',
  },
  searchPlaceholder: {
    id: 'profilesPage.searchPlaceholder',
    description: 'Common search placeholder on Profiles page',
    defaultMessage:
      'Search profiles by manufacturer, model, or device class...',
  },
  noProfilesFoundMessage: {
    id: 'profilesPage.noProfilesFoundMessage',
    description: 'No profiles found message on Team page',
    defaultMessage: 'No profiles found',
  },
  uploadedSuccessModalMessage: {
    id: 'profilesPage.uploadedSuccessModalMessage',
    description: 'Success Modal Message after profile upload on Profiles page',
    defaultMessage: '<b>{uploadedFilename}</b> uploaded!',
  },
  manufacturerColumn: {
    id: 'profilesPage.manufacturerColumn',
    description: 'Label for table column "manufacturer" on Profiles page',
    defaultMessage: 'Manufacturer',
  },
  modelColumn: {
    id: 'profilesPage.modelColumn',
    description: 'Label for table column "model" on Profiles page',
    defaultMessage: 'Model',
  },
  versionColumn: {
    id: 'profilesPage.versionColumn',
    description: 'Label for table column "version" on Profiles page',
    defaultMessage: 'Version',
  },
  uploadedColumn: {
    id: 'profilesPage.uploadedColumn',
    description: 'Label for table column "uploaded" on Profiles page',
    defaultMessage: 'Uploaded',
  },
  deviceClassColumn: {
    id: 'profilesPage.deviceClassColumn',
    description: 'Label for table column "deviceClass" on Profiles page',
    defaultMessage: 'Device Class',
  },
  deleteProfileModalTitle: {
    id: 'profilesPage.deleteProfileModalTitle',
    description: 'Title for Delete profile Modal on Profiles page',
    defaultMessage: 'Delete profile',
  },
  deleteProfileModalDescription: {
    id: 'profilesPage.deleteProfileModalDescription',
    description: 'Description for Delete profile Modal on Profiles page',
    defaultMessage:
      'Permanently delete {manufacturer}_{model} profile?{br}This action cannot be undone.',
  },
  uploadProfileButtonLabel: {
    id: 'profilesPage.uploadProfileButtonLabel',
    description: 'Label for upload profile button on Profiles page',
    defaultMessage: 'Upload Profile',
  },
  uploadProfileModalTitle: {
    id: 'profilesPage.uploadProfileModalTitle',
    description: 'Title for upload profile modal on Profiles page',
    defaultMessage: 'Upload profile file',
  },
  uploadProfileModalDesc: {
    id: 'profilesPage.uploadProfileModalDesc',
    description: 'Description for upload profile modal on Profiles page',
    defaultMessage: 'Drag and drop an .xml profile to upload.',
  },
  uploadProfileResolutionError: {
    id: 'profilesPage.uploadProfileResolutionError',
    description:
      'Description for upload profile resolution error on Profiles page',
    defaultMessage: 'Currently RMS only supports uploading .xml profiles',
  },
  uploadProfileParsingError: {
    id: 'profilesPage.uploadProfileParsingError',
    description:
      'Description for upload profile parsing error on Profiles page',
    defaultMessage: 'Error parsing profile',
  },
  uploadProfileZipError: {
    id: 'profilesPage.uploadProfileZipError',
    description:
      'Description for upload profile zipping error on Profiles page',
    defaultMessage: 'Error generating a zip of your profile, {err}',
  },
  uploadProfileFileError: {
    id: 'profilesPage.uploadProfileFileError',
    description: 'Description for upload profile error on Profiles page',
    defaultMessage:
      'Profile upload failed. There may be an issue with your file.',
  },
})
